import { useContext } from 'react'
import PropTypes from 'prop-types'
import swal from 'sweetalert2'

import { DashboardModuleListItem } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import useAgencyProviderDeadlineGroup, { useRelations } from '@hooks/useAgencyProviderDeadlineGroup'

import ScopedConditionalContent from '@components/ScopedConditionalContent'

const confirmDelete = (deleteAgencyProviderDeadlineGroup, deleteFn) => {
  const agencyProviderDeadlineGroupPayload = {
    callbacks: {
      action: deleteFn,
    },
    toastText: 'Deadline Group Removed',
  }

  swal.fire({
    confirmButtonColor: '#DD6B55',
    confirmButtonText: 'Yes, remove it.',
    icon: 'warning',
    showCancelButton: true,
    text: 'Are you sure?',
    title: 'Remove Deadline Group?',
  }).then(({ value }) => {
    if (value){
      deleteAgencyProviderDeadlineGroup(agencyProviderDeadlineGroupPayload)
    }
  })
}

const AgencyProviderDeadlineGroupListItem = (props) => {
  const { agencyProviderDeadlineGroup } = props

  const pageContext = useContext(PageContext)
  const { callbacks } = pageContext
  const { deleteAgencyProviderDeadlineGroup } = callbacks || {}

  const {
    callbacks: {
      createOrEditAgencyProviderDeadlineGroup,
      deleteAgencyProviderDeadlineGroup: deleteFn,
    },
  } = useAgencyProviderDeadlineGroup(agencyProviderDeadlineGroup)

  const { provider, providerDeadlineGroup } = useRelations(agencyProviderDeadlineGroup)

  const {
    deadlines,
    id,
    title,
  } = providerDeadlineGroup

  const deadlineCount = Object.values(deadlines).reduce((acc, deadline) => {
    if (deadline.time) acc += 1
    return acc
  }, 0)

  return (
    <DashboardModuleListItem
      secondaryText={deadlineCount === 1 ? '1 Deadline' : `${deadlineCount} Deadlines`}
      title={`# ${id} ${provider.title}`}
    >
      <DashboardModuleListItem.TertiaryText>
        {title}
      </DashboardModuleListItem.TertiaryText>

      <ScopedConditionalContent permittedRoleTitles={['Admin', 'Support']}>
        <DashboardModuleListItem.Actions>
          <DashboardModuleListItem.Icon
            marginRight="medium"
            onClick={() => createOrEditAgencyProviderDeadlineGroup()}
            type="edit"
          />

          <DashboardModuleListItem.Icon
            onClick={() => confirmDelete(deleteAgencyProviderDeadlineGroup, deleteFn)}
            type="delete"
          />
        </DashboardModuleListItem.Actions>
      </ScopedConditionalContent>
    </DashboardModuleListItem>
  )
}

AgencyProviderDeadlineGroupListItem.propTypes = {
  agencyProviderDeadlineGroup: PropTypes.object.isRequired,
}

export default AgencyProviderDeadlineGroupListItem
